import { Component, OnInit, Input } from '@angular/core';
import { environment } from '../../../constants'
import { Equiv } from '../../../model/equiv'
import { ItemListComponent } from '../item-list/item-list.component'
import { ViewEncapsulation } from '@angular/core';
import { FormGroup, UntypedFormControl, FormsModule, Validators } from '@angular/forms'
import { StringValidator } from '../base-item/string.validator'

declare var require: any

@Component({
  selector: 'app-equiv-list',
  templateUrl: '../item-list/item-list.component.html',
  styleUrls: ['../../../styles/global.scss','../item-list/item-list.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class EquivListComponent extends ItemListComponent {


// OVERRIDDEN METHODS:

  getLinkToEdit(item) {
    // console.log("Item = ", item)
    return "/data/constants/equivs/"+this.getItemId(item)
  }

  getItemsName() {
    return "Equivalents"
  }

  getItemName() {
    return "Equivalent"
  }

  getItemId(item) {
    return item.name
  }

  addItemTHValues(tableid) {
    let str = ""
    let tab = document.getElementById(tableid)
    if (!tab)
      return
    let elem = this.addElement(tab, "thead", '')
    if (!elem)
      return
    while (elem.firstChild) {
      elem.removeChild(elem.lastChild)
    }
    this.addElement(elem, 'th', 'Name')
    this.addElement(elem, 'th', 'Equivalent')
    this.addElement(elem, 'th', '')
  }


  addItemTDValues(item) {
    let elem = document.getElementById(this.getTableId())
    if (!elem)
      return
    let tr = this.addElement(elem, "tr", '')
    if (!tr)
      return
    this.addElement(tr, 'td', this.getItemId(item))
    tr.onclick = (event) => this.editItem(event, item)
    this.addElement(tr, 'td', item.equiv)
    let btn = this.addDeleteButtonIcon(tr, 'td', this.canEdit())
    btn.onclick = (event) => this.askDeleteItem(event, item)
  }

  // addNewItemTDValues() {
  //   let elem = document.getElementById("newtable")
  //   if (!elem)
  //     return
  //   let tr = this.addElement(elem, "tr", '')
  //   if (!tr)
  //     return
  //   let el = this.addElement(tr, 'td', '')
  //   let fld = document.createElement('input')
  //   el.appendChild(fld)
  //   el = this.addElement(tr, 'td', '')
  //   fld = document.createElement('input')
  //   el.appendChild(fld)
  // }

  getItems() {
    document.body.style.cursor='wait';
    this.dataService.getEquivs()
        .subscribe(items => this.afterGetItems(items))
  }


  deleteItem(item) {
    document.body.style.cursor='wait';
    this.dataService.deleteEquiv(this.getItemId(item))
      .subscribe(res => this.afterSuccessfulDelete(res),
                 response => this.afterFailedDelete(response))
  }

  getValidators() {
    let vals = {}
    vals["name"] = [Validators.required] //, StringValidator.cannotContainSpace]
    vals["equiv"] = [Validators.required]
    return vals
  }

  getDisabledFields() {
    let list = []
    return list
  }

  getNewItem() {
    return Equiv.getNewItem()
  }

  createItem(form) {

    let item = new Equiv()
    this.updateValues(item, form)
    let cat = item.toJson()
    this.dataService.updateEquiv(cat)
    .subscribe(
      val => this.dataSuccess(val, 'PUT'),
      err => this.dataError(err, 'PUT'),
      () => {}
    )
  }

  // CAN WE LEAVE THIS IN BASE CLASS ONLY?
  updateValues(cat: Equiv, form: any) {
    let keys = this.getFormKeys(form)
    for (const key of keys) {
      if (form.get(key) instanceof UntypedFormControl) {
         cat[key] = form.get(key).value
      }
    }
  }

  haveDeleteAllFeature() {
    return false
  }


// END: OVERRIDDEN METHODS


}
